import { i18n } from '@lingui/core';
import { Trans } from '@lingui/react/macro';
import { Button, Modal } from '@warp-ds/react';
import type React from 'react';

interface DeleteAllModalProps {
  open: boolean;
  onCancel: () => void;
  onDelete: () => void;
}

export const DeleteAllModal: React.FC<DeleteAllModalProps> = ({ open, onCancel, onDelete }) => (
  <Modal
    open={open}
    right
    title={i18n.t({
      id: 'mobility-item-insertion.form.imageUpload.deleteAllModalHeader',
      message: 'Delete all photos',
    })}
    onDismiss={onCancel}
    style={{ zIndex: 50 }}
  >
    <p>
      <Trans
        id="mobility-item-insertion.form.imageUpload.deleteAllConfirmationText"
        comment="Confirmation message asking if user wants to delete all photos"
      >
        Are you sure you want to delete all photos?
      </Trans>
    </p>
    <div className="flex gap-8 justify-end mt-16">
      <Button type="button" onClick={onCancel}>
        <Trans
          id="mobility-item-insertion.form.imageUpload.cancel"
          comment="Text on button for canceling delete all photos"
        >
          Cancel
        </Trans>
      </Button>
      <Button primary type="button" onClick={onDelete} data-testid="delete-all-confirm">
        <Trans
          id="mobility-item-insertion.form.imageUpload.deleteAllModal"
          comment="Text on button for deleting all photos"
        >
          Delete all
        </Trans>
      </Button>
    </div>
  </Modal>
);
